module.exports = __webpack_public_path__ + "img/frame_3.87210368.png";